// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.targetGrid table {
  border: 1px solid #D5D8DC;
  border-collapse: collapse;
}
.targetGrid td {
  border: thin solid #D5D8DC;
  padding: 10px;
}

.targetGrid .verticalText span {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: left;
  max-height: 100px;
}

.targetGrid .greenCell {
  background-color: #A3E4D7 ;
  color: #0E6251;
}

.targetGrid .yellowCell {
  background-color: #FCF3CF;
  color: #7D6608;
}

.targetGrid .redCell {
  background-color: #FADBD8;
  color: #78281F;
}

.targetGrid .grayCell {
  background-color: #E5E8E8;
  color: #424949;
}

.targetGrid .darkGreenCell {
  background-color: #68D3BD;
  color: #424949;
}

.targetGrid .darkRedCell {
  background-color: #f19c94;
  color: #424949;
}`, "",{"version":3,"sources":["webpack://./src/scene-d/Target/TargetView/TargetScorecard/TargetGrid/TargetGrid.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".targetGrid table {\n  border: 1px solid #D5D8DC;\n  border-collapse: collapse;\n}\n.targetGrid td {\n  border: thin solid #D5D8DC;\n  padding: 10px;\n}\n\n.targetGrid .verticalText span {\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  text-align: left;\n  max-height: 100px;\n}\n\n.targetGrid .greenCell {\n  background-color: #A3E4D7 ;\n  color: #0E6251;\n}\n\n.targetGrid .yellowCell {\n  background-color: #FCF3CF;\n  color: #7D6608;\n}\n\n.targetGrid .redCell {\n  background-color: #FADBD8;\n  color: #78281F;\n}\n\n.targetGrid .grayCell {\n  background-color: #E5E8E8;\n  color: #424949;\n}\n\n.targetGrid .darkGreenCell {\n  background-color: #68D3BD;\n  color: #424949;\n}\n\n.targetGrid .darkRedCell {\n  background-color: #f19c94;\n  color: #424949;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
